import React from 'react'
import { Box } from '../Styled'
import { Link } from 'react-router-dom'
import { CustomerAddress } from 'lib/types/core'
import { FormattedMessage } from 'react-intl'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { ShippingData } from '../../../../components/ShippingData'

interface Props {
  address: CustomerAddress
  label: string
}

export const DefaultAddress: React.FC<Props> = ({ address, label }) => (
  <Box>
    <FlexWrapper className='flex-box'>
      <h3><FormattedMessage id={label} /></h3>
      <Link to='/customer/account/addresses' className='toRight'>
        <FormattedMessage id='customer.account.dashboard.edit' />
      </Link>
    </FlexWrapper>
    <ShippingData address={address} />
  </Box>
)
